import { AfterViewInit, Component, ViewChild, ViewEncapsulation } from '@angular/core';
import { DxDataGridComponent } from 'devextreme-angular';
import { Globals } from '../../../globals';
import { UserService } from '../../../services/user.service';
import { TdoClientConfigurationModel } from '../../../models/clients/tdo-client-configuration.model';
import { TdoUserConfigurationModel } from '../../../models/configuration/user/tdo-user-configuration.model';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { DialogService } from '../../../services/dialog.service';
import { TdoUserInGroupConfigurationModel } from '../../../models/configuration/user/tdo-user-in-group-configuration.model';
import { TdoUserGroupConfigurationModel } from '../../../models/configuration/user/tdo-user-group-configuration.model';
import { UserConfigurationGroupDialogComponent } from './dialogs/user-configuration-group-dialog/user-configuration-group-dialog.component';
import { ContactDataModel } from '../../../models/person/contact-data.model';
import { AddressDataModel } from '../../../models/person/address-data.model';
import { StaticDataService } from '../../../services/static-data.service';
import { stateList } from '../../../constants';
import { AutofillService } from '../../../services/autofill.service';
import { ContactCommsDataModel } from '../../../models/person/contact-comms-data.model';
import { MatTabChangeEvent } from '@angular/material/tabs';
import { EnumValidValueItemModel } from '../../../models/enum/enum-valid-value-item.model';
import { EnterpriseService } from '../../../services/enterprise.service';
import { TdoColorSchemePickerEvent } from '../../../tdo-controls/common/tdo-color-scheme-picker/models/tdo-color-scheme-picker.event';
import { TdoTableV2Component } from '../../../tdo-controls/common/tdo-table-v2/tdo-table-v2.component';
import { TdoTableSelectionEvent } from '../../../tdo-controls/common/tdo-table-v2/models/tdo-table-selection.event';
import { ConfigurationService } from '../configuration.service';
import { finalize } from 'rxjs/operators';
import { UserRoleEnum } from 'src/app/models/enum/user-role.enum';

@Component({
  selector: 'app-user-list',
  templateUrl: './user-list.component.html',
  styleUrls: ['./user-list.component.scss'],
  encapsulation: ViewEncapsulation.None,
})

export class UserListComponent implements AfterViewInit {
  @ViewChild(DxDataGridComponent) dataGrid: DxDataGridComponent;
  @ViewChild('userTable') userTable: TdoTableV2Component;

  clientList: TdoClientConfigurationModel[];
  userList: TdoUserConfigurationModel[];
  selectedClient: TdoClientConfigurationModel;
  selectedUser: TdoUserConfigurationModel;
  hide: boolean = true;
  isShowErx: boolean = false;

  saveIndicatorVisible = false;
  saveButtonText = 'Save';
  isNewUser: boolean = false;
  isBusy: boolean = true;
  isSaving = false;
  userContact: ContactDataModel = new ContactDataModel();

  userInGroups: TdoUserInGroupConfigurationModel[];
  userGroups: TdoUserGroupConfigurationModel[];
  stateList: string[];
  salutationEnums: EnumValidValueItemModel[];

  showPassword: boolean = false;
  isResettingCredentials: boolean = false;
  isUserNameValid: boolean = true;
  isUsernameEdit: boolean = false;

  phoneMask: any[] = ['(', /[1-9]/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/];
  soundPaths: object[] = [{ name: 'notification.wav' }, { name: 'notification_bk.wav' }];
  eRxParametersJSON: any;
  showERxParameters: boolean = false;
  userLevels: any[] = [
    { UserLevel: "Provider", value: 0 },
    { UserLevel: "Staff - Full", value: 1 },
    { UserLevel: "Staff - MidHigh", value: 2 },
    { UserLevel: "Staff - Mid", value: 3 },
    { UserLevel: "Staff - Read Only", value: 4 },
    { UserLevel: "Staff - Admin Only", value: 5 },
  ]

  constructor(
    private readonly userService: UserService,
    private readonly enterpriseService: EnterpriseService,
    private readonly dialogService: DialogService,
    private readonly globals: Globals,
    private readonly dialog: MatDialog,
    private readonly staticDataService: StaticDataService,
    private readonly autofillService: AutofillService,
    public configurationService: ConfigurationService,
    private snackBar: MatSnackBar) {
    this.stateList = stateList;
  }

  ngAfterViewInit(): void {
    if (!this.staticDataService.isReady) {
      this.staticDataService.validValuesReadyEvent.subscribe({
        complete: () => {
          this.loadEnums();
        }
      });
    } else {
      this.loadEnums();
    }
  }

  loadEnums() {
    this.salutationEnums = this.staticDataService.getValidValueItemsByValidValueName('enumSalutation');
    this.loadUsers();
  }

  loadUsers() {
    this.enterpriseService.getClients().subscribe((data) => {
      this.clientList = data;
      const client = this.clientList.find(p => p.TDOCID === parseInt(this.globals.TDOCID));
      if (client) {
        this.selectedClient = client;
      } else {
        this.selectedClient = this.clientList[0];
      }
      this.userService.getUserGroups(this.selectedClient.TDOCID).subscribe((res1) => {
        console.log("loadUsers getUserGroups", res1)
        this.userGroups = res1;
      });

      this.userService.getUsers(this.selectedClient.TDOCID.toString()).subscribe(udata => {
        this.userList = udata;
        if (udata && udata?.length > 0) {
          this.changeUser(udata[0]);
          this.userTable.updateData(this.userList);
        }
        this.isBusy = false;
      }, err => {
        console.log(err);
        this.isBusy = false;
      });
    }, err => {
      this.isBusy = false;
      console.log(err);
    }
    );
  }

  onChangeClient(client: TdoClientConfigurationModel) {
    const l = this.configurationService.checkIsDirty();
    if (l) {
      l.subscribe((res) => {
        if (res) {
          this.changeClient(client);
        } else {
          this.userTable.selectionControl.select(this.selectedUser);
        }
      });
    } else {
      this.changeClient(client);
    }
  }

  changeClient(client: TdoClientConfigurationModel) {
    this.selectedClient = client;
    this.isNewUser = false;
    this.isBusy = true;

    this.isBusy = true;
    this.userService.getUsers(client.TDOCID.toString()).subscribe(udata => {
      this.userList = udata;
      this.selectedUser = this.userList[0];
      this.userService.getUserGroups(this.selectedClient.TDOCID).subscribe((res1) => {
        console.log("changeClient getUserGroups", res1)

        this.userGroups = res1;
        this.isBusy = false;
        this.setShowERxParameters();
      });
      this.userTable.updateData(this.userList);
    }, err => {
      console.log(err);
      this.isBusy = false;
    });
  }

  onNew(e) {
    this.configurationService.setDirty();
    const model = new TdoUserConfigurationModel();
    model.TDOCID = this.selectedClient.TDOCID;
    model.UserName = '';
    model.FirstName = '';
    model.MidName = '';
    model.LastName = '';
    model.UserNickName = '';
    this.userList.unshift(model);
    this.userTable.updateData(this.userList);
    this.selectedUser = model;
    this.userTable.selectionControl.select(this.selectedUser);
    this.userInGroups = [];
    this.userContact = new ContactDataModel();
  }


  onSave(e) {
    this.saveIndicatorVisible = true;
    this.saveButtonText = 'Saving';
    if (e) {
      this.isSaving = true;
      this.isBusy = true;
    }
    this.selectedUser.ERxParametersJSON = JSON.stringify(this.eRxParametersJSON);
    this.userService.saveUser(this.selectedUser.UserID == null, this.selectedUser).subscribe(resp => {
      if (resp) {
        console.log("User saved: ", this.isNewUser, resp);
        if (this.isNewUser)
          this.showMessage('Success', `User Created. Password Assigned : ${resp.UserPassword}`, 10000);

        this.configurationService.setClean();
        const oldUserIdx = this.userList.findIndex(p => p === this.selectedUser);
        if (oldUserIdx > -1) {
          this.userList.splice(oldUserIdx, 1, resp);
        }

        this.isBusy = false;
        this.selectedUser = resp;
        const ivl = setInterval(() => {
          if (this.userTable) {
            clearInterval(ivl);
            this.userTable.updateData(this.userList);
            this.userTable.selectionControl.select(this.selectedUser);
          }
        }, 100);

        this.userService.getUserContact(this.selectedUser.ContactId).subscribe((res2) => {
          if (res2) {
            this.userContact = res2;
          } else {
            this.userContact = new ContactDataModel();
            this.userContact.ContactId = this.selectedUser.ContactId;
          }
        });


        if (!this.userContact.ContactId) {
          this.userContact.ContactId = this.selectedUser.ContactId;
        }
        this.userService.saveUserContact(this.userContact).subscribe((res) => {
          this.userContact = res;
          this.isBusy = false;
          this.isSaving = false;
        },
          err => {
            console.log(err);
            this.showMessage('Error', `Error saving user contact : ${err.error.ExceptionMessage ?? err.error.Message ?? err.error}`);
          });

        this.isNewUser = false;
      }
      else {

        this.isBusy = false;
        this.isSaving = false;
        this.showMessage('Error', 'Error saving user.');
        console.log("User saved error: ", resp);
      }

    },
      err => {
        console.log("User saved error: ", err);

        this.isBusy = false;
        this.isSaving = false;
        console.log(err);
        this.showMessage('Error', `Error saving user : ${err.error.ExceptionMessage ?? err.error.Message ?? err.error}`);
      });


  }

  showMessage(type, message, duration = 3000) {
    this.snackBar.open(message, type, {
      duration: duration,
      verticalPosition: 'top'
    });
  }
  checkIfContactDetailsRequireCopy() {
    if (!this.userContact.FirstName || (this.userContact.FirstName && this.userContact.FirstName.length === 0)) {
      this.userContact.FirstName = this.selectedUser.FirstName;
    }

    if (!this.userContact.MidName || (this.userContact.MidName && this.userContact.MidName.length === 0)) {
      this.userContact.MidName = this.selectedUser.MidName;
    }

    if (!this.userContact.LastName || (this.userContact.LastName && this.userContact.LastName.length === 0)) {
      this.userContact.LastName = this.selectedUser.LastName;
    }

    if (!this.userContact.AKA) {
      this.userContact.AKA = this.selectedUser.UserNickName;
    }

    if (!this.userContact.enumSalutationID) {
      this.userContact.enumSalutationID = this.selectedUser.enumSalutationID;
    }
  }

  addUserInGroup() {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.data = {
      groups: this.userGroups,
      userInGroups: this.userInGroups
    };
    dialogConfig.panelClass = 'dialog';
    console.log("AddUserInGroup: ", this.userInGroups);
    this.dialog.open(UserConfigurationGroupDialogComponent, dialogConfig).afterClosed().subscribe(
      (res: TdoUserInGroupConfigurationModel[]) => {
        if (res && res.length > 0) {
          const models: TdoUserInGroupConfigurationModel[] = [];
          for (const uig of res) {
            const model = new TdoUserInGroupConfigurationModel();
            model.UserGroupId = uig.UserGroupId;
            model.UserID = this.selectedUser.UserID;
            models.push(model);
          }

          this.userService.saveUserInGroups(models).subscribe((response) => {
            for (const r of response) {
              this.userInGroups.push(r);
            }
            this.setShowERxParameters();
          });
        }
      });
  }

  deleteUserInGroupItem(item: TdoUserInGroupConfigurationModel) {
    this.dialogService.openConfirmDialog(`Are you sure you want to delete ${this.getUserRoleFromUserInGroup(item)}?`).subscribe((res) => {
      if (res) {
        this.userService.deleteUserInGroups([item]).subscribe(() => {
          const idx = this.userInGroups.findIndex(p => p.UserGroupId === item.UserGroupId && p.UserID === item.UserID);
          if (idx > -1) {
            this.userInGroups.splice(idx, 1);
            this.setShowERxParameters();
          }
          
        });
      }
    });
  }

  getUserRoleFromUserInGroup(item: TdoUserInGroupConfigurationModel) {
    if (this.userGroups) {
      const ret = this.userGroups.find(p => p.UserGroupId === item.UserGroupId);
      if (ret) {
        return ret.UserGroupName;
      } else {
        return null;
      }
    }
  }

  isUserInRole(userID: string, roleID: string) {
    if (this.userInGroups && this.userGroups) {
      const groups = this.userInGroups?.filter(p => p.UserID === userID).map(p => p.UserGroupId);
      console.log("isUserInRole groups", groups);
      console.log("isUserInRole usergroups", this.userGroups);
      return this.userGroups?.some(p => groups.includes(p.UserGroupId) && p.cfgTDOUserGroupRoles.some(p => p.RoleId === roleID));
    }
    return false;
  }

  onDateChange($event: Event) {
    this.configurationService.setDirty();
  }

  getAddressCategory(cat: string) {
    const enu = this.staticDataService.validValueItems.find(p => p.ValidValueItemId === cat);
    if (enu) {
      return enu.ItemDisplayValue;
    }

    return '';
  }

  getAddress(address: AddressDataModel) {
    let ret = '';
    if (address.Address1) {
      ret += address.Address1;
    }
    if (address.City) {
      ret += ' ' + address.City;
    }
    if (address.State) {
      ret += ', ' + address.State;
    }
    if (address.PostCode) {
      ret += ', ' + address.PostCode;
    }
    return ret;
  }

  addNewAddress() {
    const model = new AddressDataModel();
    model.ContactId = this.userContact.ContactId;
    this.userContact.dataAddresses.push(model);
  }

  deleteAddress(event: MouseEvent, address: AddressDataModel) {
    event.stopImmediatePropagation();
    this.dialogService.openConfirmDialog('Are you sure you want to delete this address?').subscribe((res) => {
      if (res) {
        let idx: number;
        if (address.AddressId) {
          this.userService.deleteContactAddress(address).subscribe(() => {
            idx = this.userContact.dataAddresses.findIndex(p => p.AddressId === address.AddressId);
            if (idx > -1) {
              this.userContact.dataAddresses.splice(idx, 1);
            }
          });
        } else {
          idx = this.userContact.dataAddresses.findIndex(p => p === address);
          if (idx > -1) {
            this.userContact.dataAddresses.splice(idx, 1);
          }
        }
      }
    });
  }

  onAddressCategoryChange(event: string, address: AddressDataModel) {
    address.typeDescription = event;
  }

  onAddress1Blur(event, address: AddressDataModel) {
    if (event.target.value) {
      this.autofillService.getAddressDataFromInput(event.target.value).subscribe((response) => {
        address.City = response.city;
        address.State = response.stateAbbreviation;
        address.PostCode = response.zipcode;
      });
    }
  }

  onZipCodeInput(event, address: AddressDataModel) {
    address.PostCode = event.target.value;
    if (event.target.value.length === 5) {
      this.autofillService.getAddressDataFromInput(event.target.value).subscribe((response) => {
        address.City = response.city;
        address.State = response.stateAbbreviation;
      });
    }
  }

  addNewComm() {
    const model = new ContactCommsDataModel();
    model.ContactId = this.userContact.ContactId;
    this.userContact.dataContactComms.push(model);
  }

  deleteComm(event: MouseEvent, communicationObj: ContactCommsDataModel) {
    event.stopImmediatePropagation();
    this.dialogService.openConfirmDialog('Are you sure you want to delete this communication?').subscribe((res) => {
      if (res) {
        let idx: number;
        if (communicationObj.CommMethID) {
          this.userService.deleteContactCommunication(communicationObj).subscribe((res1) => {
            idx = this.userContact.dataContactComms.findIndex(p => p.CommMethID === communicationObj.CommMethID);
            if (idx > -1) {
              this.userContact.dataContactComms.splice(idx, 1);
            }
          });
        } else {
          idx = this.userContact.dataContactComms.findIndex(p => p === communicationObj);
          if (idx > -1) {
            this.userContact.dataContactComms.splice(idx, 1);
          }
        }
      }
    });
  }

  getPatientHomeAddress() {
    if (this.userContact) {
      const homeAddress = this.userContact.dataAddresses.find(p => p.enumAddressCategoryID === '00000008-1000-0000-0000-000000000001');
      if (homeAddress) {
        return homeAddress;
      } else {
        return null;
      }
    }
    return null;
  }

  clearAddress(communicationObj: ContactCommsDataModel) {
    communicationObj.Address = '';
  }

  onMainTabGroupChange(event: MatTabChangeEvent) {
    switch (event.tab.textLabel) {
      case 'Contact':
        this.checkIfContactDetailsRequireCopy();
        break;
      case 'Groups':
        if (!this.selectedUser.UserID) {
          this.onSave(null);
        }
        break;
    }
  }

  getType() {
    if (this.showPassword) {
      return 'text';
    } else {
      return 'password';
    }
  }

  onColorSchemeChange(event: TdoColorSchemePickerEvent) {
    this.selectedUser.ColorSchemeID = event.value.ColorSchemeId;
  }

  getSound() {
    return this.soundPaths.find(p => p['name'] === this.selectedUser.UserSound);
  }

  playSound() {
    const audio = new Audio();
    audio.src = 'assets/sounds/user/' + this.selectedUser.UserSound;
    audio.load();
    audio.play();
  }

  deleteUser(model: TdoUserConfigurationModel) {
    this.dialogService.openConfirmDialog(`Are you sure you want to delete ${model.UserName}?`).subscribe((result) => {
      if (result === true) {
        this.userService.deleteUser(model).subscribe((res) => {
          const idx = this.userList.findIndex(p => p === model);
          if (idx > -1) {
            this.userList.splice(idx, 1);
            this.userTable.updateData(this.userList);
          }
        });
      } else {
        //
      }
    });
  }

  onUserSelected(event: TdoTableSelectionEvent) {
    const l = this.configurationService.checkIsDirty();
    if (l) {
      l.subscribe((res) => {
        if (res) {
          this.changeUser(event.model);
        } else {
          this.userTable.selectionControl.select(this.selectedUser);
        }
      });
    } else {
      this.changeUser(event.model);
    }
  }

  changeUser(user: TdoUserConfigurationModel) {
    this.selectedUser = user;
    this.isUserNameValid = true;
    if (this.selectedUser.ContactId) {
      this.userService.getUserContact(this.selectedUser.ContactId).subscribe((res2) => {
        if (res2) {
          this.userContact = res2;
        } else {
          this.userContact = new ContactDataModel();
          this.userContact.ContactId = this.selectedUser.ContactId;
        }
        this.checkIfContactDetailsRequireCopy();
      });
    } else {
      this.userContact = new ContactDataModel();
      this.userContact.ContactId = this.selectedUser.ContactId;
      this.checkIfContactDetailsRequireCopy();
    }
    this.userService.getUserInGroups(this.selectedUser.UserID).subscribe((res) => {
      this.userInGroups = res;
      console.log("getUserInGroups", this.userInGroups);
      this.setShowERxParameters();
    });

    this.isShowErx

  }

  resetCredentials() {
    this.dialogService.openConfirmDialog(`Are you sure you want to reset credentials for ${this.selectedUser.UserName}`).subscribe((res) => {
      if (res) {
        this.isSaving = true;
        this.isBusy = true;
        this.isResettingCredentials = true;
        this.userService.resetCredentials(this.selectedUser).pipe(
          finalize(() => {
            this.isBusy = false;
            this.isSaving = false;
            this.isResettingCredentials = false;
          })).subscribe((response) => {
            console.log("resetCredentials");
            console.log(response);
            if (response) {
              this.showMessage('Success', `User credentials changed. Password Assigned : ${response}`, 10000);
            }
          },
            err => {
              console.log(err);
              this.showMessage('Error', `Error modifying credentials : ${err.error.ExceptionMessage ?? err.error.Message ?? err.error}`, 5000);
            });
      }
    });
  }



  changeUserName(event: Event) {
    const username = (event.target as HTMLInputElement).value;
    if (username) {
      this.userService.checkUsernameAvailable(username).subscribe((res) => {
        this.isUserNameValid = res;
        if (this.isUserNameValid) {
          this.selectedUser.UserName = username;
          this.configurationService.setDirty();
          this.isUsernameEdit = false;
        }
        else {
          this.showMessage('Error', `Username ${username} is invalid.`, 5000);
        }
      });
    }
  }

  setShowERxParameters() {
    console.log("setShowERxParameters:", this.selectedUser.ERxParametersJSON);
    if (!this.selectedUser.ERxParametersJSON)
      this.selectedUser.ERxParametersJSON ='{"User_Level":""}';
    this.eRxParametersJSON = JSON.parse(this.selectedUser.ERxParametersJSON);
    this.showERxParameters = this.isUserInRole(this.selectedUser.UserID, UserRoleEnum.Erx);
    console.log("showERxParameters:", this.showERxParameters);
  }

  trackByFn(i: number, items: any) {
    return i; // returning the index itself for avoiding ngFor to change focus after ngModelChange
  }

  setERXUserLevel(event: any) {
    console.log("setERXUserLevel:", event);
    this.eRxParametersJSON["User_Level"] = event.value.value;
    console.log("setERXUserLevel", this.eRxParametersJSON);
  }
}
